import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import BuildingComponent from "../../components/hw/BuildingComponent";
import { useNavigate, useParams } from "react-router-dom";
import PrivateApi from "../../services/PrivateApiService";
import SplashPage from "../SplashPage";
import ElvTable from "../../components/elvs/ElvTable";
import { useQuery } from "react-query";
import { CgSandClock } from "react-icons/cg";


/**
 * ElvPage
 * 
 * page for displaying all active Elvs
 * 
 * This page has 2 entry points. 
 * 1. from DashboardPage which shows all active Evls
 * 2. from BuildingPage which shows active Elvs for this Building
 * 
 * when entry point is from BuildingPage, building information and Anlagen
 * will be displayed. Anlagen are used as filters for Elvs.
 * 
 * @returns none
 */
const ElvPage = () => {

    const API = new PrivateApi(); // API calls
    const navigate = useNavigate(); // navigation

    // parameters that are passed.
    // buildingId is used for call Elvs from this building only.
    // anlageId is used to preselect anlage and filter Elvs
    const { buildingId } = useParams() || null;
    
    const [anlagen, setAnlagen] = useState([]); // array state for Anlagen
    const [selectedAnlageId, setSelectedAnlageId] = useState([]); // array state when Anlage is clicked

    const [building, setBuilding] = useState(); // state for building object
    const [elvs, setElvs] = useState([]); // array state for Elvs

    const { data, error, isLoading } = useQuery(["GET_BUILDING_ELVS", buildingId], () => API.get_ElvsBuilding(buildingId), {
        enabled: buildingId !== undefined,
        staleTime: Infinity,
    });
    const { data: dataElv, error: errorElv, isLoading: isLoadingElv } = useQuery("GET_ELVS", API.get_ElvsAll, {
        enabled: buildingId === undefined,
        staleTime: Infinity,
    })

    useEffect(() => {
        if (dataElv) {
            setAnlagen(dataElv.data.anlagen);
            setElvs(dataElv.data.elvs.sort((a, b) => new Date(b.x_belbeg).getTime() - new Date(a.x_belbeg).getTime()));
        }
        if (data) {
            setBuilding(data.data.building);
            setAnlagen(data.data.anlagen);
            setElvs(data.data.elvs);
        }
    }, [dataElv, data])

    if (isLoading || isLoadingElv) return <SplashPage />;
    if (error || errorElv) return <SplashPage error={error !== undefined? error : errorElv !== undefined? errorElv : null} />;

    // GUI
    return (
        <Container className="text-start">
            <Row className="mb-5 align-items-center">
                <Col xl="6">
                    <h3>{building ? "Energielieferverträge" : "Aktive Energielieferverträge"}</h3>
                    <p className="text-muted">{building ? building.name : "Ihre laufenden Energielieferverträge"}</p>
                </Col>
                <Col xl="6" hidden={building === undefined || building === null} className="text-end">
                    <Button 
                        onClick={() => navigate(`/hw/dashboard/energieliefervertraege/zeitverlauf/${building.id}`)}
                        className="btn-energo rounded-pill"><CgSandClock size={25} /> Ansicht: Zeitverlauf</Button>
                </Col>
            </Row>
            {building ?
                <Row className="align-items-center">
                    <BuildingComponent selected={selectedAnlageId} setSelected={setSelectedAnlageId} building={building} anlagen={anlagen} />
                </Row>
                :
                null
            }
            <Row className="mt-3">
                <Col xs="12">
                    <ElvTable setSelectedAnlage={setSelectedAnlageId} selectedAnlage={selectedAnlageId} elvs={elvs} anlagen={anlagen} />
                </Col>
            </Row>
        </Container>
    )
}

export default ElvPage;